import { EventEmitter } from '@angular/core';

export class CalculationService {
  hide = false;
  loanValue;
  loanAmount;
  totalLoanPayment;
  downPayment;
  interestRate;
  downPaymentAmount;
  principle;
  principlePaymentMonth;
  principleBalanceMonth;
  term;
  noOfPayments;
  emi;
  // annualInterestPercent;
  monthlyInterestPercent;
  interestPaymentMonth;
  monthlyInstallment;
  totalInterestPayment;

  amortizationArray = [];
  arrayForGraph = [];

  dataToEmit = new EventEmitter<{
    hide: Boolean, loanValue: number, downPayment: number,
    downPaymentAmt: number, loanAmount: number, interestRate: number, loanTerm: number,
    loanTermPayments: number, emi: number, totalLoanPayment: number, totalInterestPayment: number
  }>();

  constructor() {}

  onReceivedFormData(hide: Boolean, loanValue: number, downPayment: number, interestRate: number,
    loanTerm: number) {

    if (!hide) {
      this.hide = false;
      // .toLocaleString(); used for comma after every thousand
      this.loanValue = loanValue.toLocaleString();
      this.totalLoanPayment = 0;
      this.totalInterestPayment = 0;
      this.loanAmount = (loanValue - ((loanValue * downPayment) / 100)).toLocaleString();
      this.downPaymentAmount = ((loanValue * downPayment) / 100).toLocaleString();
      this.principle = (loanValue - ((loanValue * downPayment) / 100));
      this.totalLoanPayment = this.principle;
      // this.annualInterestPercent = interestRate;
      this.monthlyInterestPercent = ((interestRate / 100) / 12);
      this.term = loanTerm;
      this.noOfPayments = (this.term * 12);

      // Amortization Formula to calculate monthly installment
      this.monthlyInstallment = (Math.round(this.principle * ((this.monthlyInterestPercent *
        (Math.pow((1 + this.monthlyInterestPercent), this.noOfPayments)))
        / ((Math.pow((1 + this.monthlyInterestPercent), this.noOfPayments)) - 1)) * 100) / 100);

      this.emi = this.monthlyInstallment.toLocaleString();

      for (let index = 0; index < this.noOfPayments; index++) {

        this.interestPaymentMonth = (Math.round((this.principle * this.monthlyInterestPercent) * 100) / 100);
        this.principlePaymentMonth = (Math.round((this.monthlyInstallment - this.interestPaymentMonth) * 100) / 100);
        this.principleBalanceMonth = (Math.round((this.principle - this.principlePaymentMonth) * 100) / 100);
        if (this.principlePaymentMonth < this.principle && this.principleBalanceMonth <= 1) {
          this.principlePaymentMonth = this.principle;
          this.principle = 0;
          this.principleBalanceMonth = this.principle;
        } else if (this.principlePaymentMonth > this.principleBalanceMonth) {
          this.principlePaymentMonth = this.principle;
          this.principle = 0;
          this.principleBalanceMonth = this.principle;
        } else {
          this.principle = this.principleBalanceMonth;
        }
        this.totalInterestPayment = (Math.round((this.totalInterestPayment + this.interestPaymentMonth) * 100) / 100);

        this.amortizationArray.push(
          {
            loanAmount: this.loanAmount.toLocaleString(),
            monthPayment: this.monthlyInstallment.toLocaleString(),
            monthInterestPayment: this.interestPaymentMonth.toLocaleString(),
            monthPrinciplePayment: this.principlePaymentMonth.toLocaleString(),
            monthPrincipleBalance: this.principleBalanceMonth.toLocaleString()
          }
        );
      }

      this.totalLoanPayment = (Math.round((this.totalLoanPayment + this.totalInterestPayment) * 100) / 100);
      this.totalLoanPayment = this.totalLoanPayment.toLocaleString();

      this.totalInterestPayment = this.totalInterestPayment.toLocaleString();

      this.dataToEmit.emit({
        hide: this.hide, loanValue: this.loanValue, downPayment: downPayment,
        downPaymentAmt: this.downPaymentAmount, loanAmount: this.loanAmount, interestRate: interestRate,
        loanTerm: this.term, loanTermPayments: this.noOfPayments, emi: this.emi, totalLoanPayment: this.totalLoanPayment,
        totalInterestPayment: this.totalInterestPayment
      });

    } else {
      this.hide = true;
      this.loanValue = '';
      this.downPayment = '';
      this.downPaymentAmount = '';
      this.loanAmount = '';
      this.interestRate = '';
      this.term = '';
      this.noOfPayments = '';
      this.emi = '';
      this.totalLoanPayment = '';
      this.totalInterestPayment = '';

      this.amortizationArray.splice(0, this.amortizationArray.length);

      this.dataToEmit.emit({
        hide: this.hide, loanValue: this.loanValue, downPayment: this.downPayment,
        downPaymentAmt: this.downPaymentAmount, loanAmount: this.loanAmount, interestRate: this.interestRate,
        loanTerm: this.term, loanTermPayments: this.noOfPayments, emi: this.emi, totalLoanPayment: this.totalLoanPayment,
        totalInterestPayment: this.totalInterestPayment
      });

    }

  }
}



// WEBPACK FOOTER //
// D:/IT-Projects/Projects/amortization/amortization-v03.1.1/src/app/calculation.service.ts